<template>
  <div>
    <PageTitle
      icon="fa fa-cogs"
      main="Administração"
      sub="Histórico de Ações"
      :help="true"
    />
    <card>
      <div class="row">
        <div class="col-md-4 col-sm-12">
          <label class="form-control-label">Usuário</label>
          <multiselect
            placeholder="Selecione o usuário"
            v-model="filter.whodunnit"
            :options="users"
            :select-label="''"
            :deselect-label="''"
            :selected-label="'Selecionado'"
            label="name"
            track-by="id"
            @search-change="getUsers"
          />
        </div>
        <div class="col-md-4 col-sm-12">
          <label class="form-control-label">Módulo</label>
          <multiselect
            placeholder="Selecione o Módulo"
            v-model="filter.itemType"
            :options="itemTypes"
            label="translation"
            :select-label="''"
            :deselect-label="''"
            :selected-label="'Selecionado'"
            track-by="value" />
        </div>

        <div class="col-md-4 col-sm-12">
          <label class="form-control-label">Ação</label>
          <multiselect
            v-model="filter.event"
            :options="events"
            :select-label="''"
            :deselect-label="''"
            :selected-label="'Selecionado'"
            placeholder="Selecione a ação"
            label="translation"
            track-by="value"
            :show-no-options="false" />
        </div>

        <div class="col-6">
          <label class="form-control-label d-block mb-2 mt-3" >A partir de</label>
          <el-date-picker
            v-model="filter.startDate"
            type="date"
            placeholder="Data início"
            prefix-icon="fa fa-calendar"
            format="d 'de' MMMM 'de' yyyy"
            rules="required"
            :editable="true"
            value-format="yyyy-MM-dd"
          />
        </div>
        <div class="col-6">
          <label class="form-control-label d-block mb-2 mt-3" >Até</label>
          <el-date-picker
            v-model="filter.endDate"
            type="date"
            placeholder="Data Fim"
            prefix-icon="fa fa-calendar"
            format="d 'de' MMMM 'de' yyyy"
            rules="required"
            :editable="true"
            value-format="yyyy-MM-dd"
          />

        </div>
      </div>
      <div slot="footer" class="row justify-content-end">
        <base-button v-loading="isLoading" type="secondary" @click="clearFilters">Limpar Pesquisa</base-button>
        <base-button v-loading="isLoading" type="primary" @click="getVersions">Pesquisar</base-button>
      </div>
    </card>
    <card>
      <div v-if="versions.length > 0">
        <el-table
          v-loading="isLoading"
          class="table-responsive table-striped clickable-rows"
          style="width: 100%; padding-top: 10px;"
          header-row-class-name="thead-light"
          :data="versions"
        >
          <el-table-column prop="user_name" label="Usuário Alterador"/>
          <el-table-column
            label="Data da Alteração"
            v-slot="{row}"
          >
            {{row.created_at }}
          </el-table-column>
          <el-table-column prop="item_type" label="Entidade Alterada"/>
          <el-table-column prop="event" label="Evento"/>
        </el-table>
        <div slot="footer" class="py-4 justify-content-end">
          <base-pagination
            v-on:input="getVersions"
            v-model="paginated_data['current']"
            :total="paginated_data['count']"
            :perPage="paginated_data['per_page']"
          ></base-pagination>
        </div>
      </div>
    </card>
  </div>
</template>
<script>
import Vue from "vue";
import { Table, TableColumn, DatePicker} from "element-ui";
import PageTitle from "@/layouts/PageTitle";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";



export default {
  name: "app",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    PageTitle,
    Multiselect,
  },
  data() {
    return {
      active: true,
      filter: {
        whodunnit: null,
        itemType: null,
        event: null,
        startDate: '',
        endDate: '',
      },
      paginated_data: [],
      versions: [],
      users: [],
      itemTypes: [],
      isLoading: false,
      events: [],
    }
  },
  mounted: function() {
    this.getUsers();
    this.initData();
  },
  methods: {
    getVersions: function(page){
      this.isLoading = true;
      if (typeof page === "undefined") page = null;

      this.$http.secured
        .get('/api/v1/admin/versions', {
          params: {
            page: page,
            "version[whodunnit]": this.filter.whodunnit
              ? this.filter.whodunnit.id
              : null,
            "version[item_type]": this.filter.itemType
              ? this.filter.itemType.value
              : null,
            "version[event]": this.filter.event
              ? this.filter.event.value
              : null,
            "version[start_date]": this.filter.startDate
              ? this.filter.startDate
              : null,
            "version[end_date]": this.filter.endDate
              ? this.filter.endDate
              : null,
          }
        })
        .then((response) => {
          this.paginated_data = response.data
          this.versions       = response.data['versions']
          this.isLoading = false;
        })
        .catch((error) => console.log("Something went wrong", error));

    },
    initData() {
      this.$http.secured
        .get("/api/v1/report/versions", { params: { data: true, q: { status: this.active } } })
        .then((response) => {
          this.events = response.data.events;
          this.itemTypes = response.data.item_types;
        });
    },
    getUsers(query) {
        var data = {
          per_page: 10,
          q: { name: query, status: true },
        };
        this.$http.secured
        .get("/api/v1/users", { params: data })
        .then(response => ( this.users = response.data.users ))
        .catch(error => console.log(error, "Something went wrong"))
    },
    replaceLineBreaks: function(text){
      return text.replace(/(\\r)*\\n/g, '<br>')
    },
    clearFilters() {
      this.filter.whodunnit = null,
      this.filter.itemType = null,
      this.filter.event = null,
      this.filter.endDate = '',
      this.filter.startDate = ''
    },
  }
}
</script>
